import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then(m => m.LoginModule)
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'solicitud-listado',
        loadChildren: () =>
          import('./pages/solicitud-listado/solicitud-listado.module').then(m => m.SolicitudListadoModule)
      },
      {
        path: 'solicitud-nueva',
        loadChildren: () =>
          import('./pages/solicitud-nueva/solicitud-nueva.module').then(m => m.SolicitudNuevaModule)
      },
      {
        path: 'presupuesto-listado',
        loadChildren: () =>
          import('./pages/presupuesto-listado/presupuesto-listado.module').then(m => m.PresupuestoListadoModule)
      },
      {
        path: 'chat',
        loadChildren: () =>
          import('./pages/chat/chat.module').then(m => m.ChatModule)
      },
      {
        path: 'panel-control',
        loadChildren: () =>
          import('./pages/panel-control/panel-control.module').then(m => m.PanelControlModule)
      },
      {
        path: 'clientes',
        redirectTo: 'panel-control/clientes',
        pathMatch: 'full'
      },
      { path: '', redirectTo: 'solicitud-listado', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
